import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLenis } from "lenis/react";
import Hero from "@/components/home/Hero";
import Intro from "@/components/home/Intro";
import Services from "@/components/home/Services";
import EditorialMarquee from "@/components/home/EditorialMarquee";
import Manifesto from "@/components/home/Manifesto";
import WhyChoose from "@/components/home/WhyChoose";
import Testimonials from "@/components/home/Testimonials";
import Numerology from "@/components/home/Numerology";
import Journal from "@/components/home/Journal";
import FinalCTA from "@/components/home/FinalCTA";
import { Seo } from "@/components/Seo";

const Home = () => {
  const location = useLocation();
  const lenis = useLenis();

  useEffect(() => {
    const targetId = location.state?.scrollTo;
    if (targetId) {
      const t = setTimeout(() => {
        const el = document.getElementById(targetId);
        if (el && lenis) lenis.scrollTo(el, { offset: -80, duration: 1.4 });
        else if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 350);
      return () => clearTimeout(t);
    }
  }, [location.state, lenis]);

  return (
    <div data-testid="home-page">
      <Seo
        title="Svara Chakra — Where Sound Becomes Sanctuary"
        description="A refined wellness ecosystem where ancient wisdom meets contemporary wellbeing — music therapy, energy healing, mindfulness and conscious living."
        path="/"
      />
      <Hero />
      <Intro />
      <EditorialMarquee />
      <Services />
      <Manifesto />
      <WhyChoose />
      <Testimonials />
      <Numerology />
      <Journal />
      <FinalCTA />
    </div>
  );
};

export default Home;
